import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";

/**
 * Reusable delete confirmation dialog.
 *
 * Props:
 *   open        — boolean, controls visibility
 *   title       — string, dialog header (e.g. "Remove Payout Mapping")
 *   message     — string | ReactNode, warning body text
 *   loading     — boolean, disables Proceed and shows loading label
 *   onConfirm   — () => void, called on Proceed click
 *   onCancel    — () => void, called on Cancel click or dialog close
 */
const DeleteConfirmDialog = ({ open, title, message, loading = false, onConfirm, onCancel }) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: "12px" } }}
        >
            <DialogTitle sx={{ fontWeight: 600, fontSize: "1.2rem" }}>
                {title}
            </DialogTitle>

            <DialogContent>
                <DialogContentText>
                    {message}
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                <Button
                    onClick={onCancel}
                    variant="outlined"
                    sx={{ textTransform: "none", borderColor: "#D9D9D9", color: "#626262" }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    disabled={loading}
                    sx={{
                        textTransform: "none",
                        backgroundColor: "#D32F2F",
                        "&:hover": { backgroundColor: "#B71C1C" },
                    }}
                >
                    {loading ? "Removing..." : "Proceed"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmDialog;
